/* eslint-disable camelcase */
import config from '../config/google'
import { getFirstGroupedNumbersIfExist } from '../libs/strings'
import { getCurrentLanguage } from '../translations/i18n'
import { MapsAPIGeocodeResponse, Location } from '../types/places'

const getApiUrlLanguage = () => {
  const language = getCurrentLanguage()
  return `${language}-${language.toUpperCase()}`
}

const getPlacesApiUrl = () => {
  const lang = getApiUrlLanguage()
  return `https://maps.googleapis.com/maps/api/js?key=
${config.googleMaps.places.API_KEY}&libraries=places&
language=${lang}`
}

const getLocationInfo = async (placeId: string, label: string) => {
  const locationResponse: MapsAPIGeocodeResponse = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?place_id=
${placeId}&key=${config.googleMaps.places.API_KEY}`
  ).then((response) => response.json())
  const {
    place_id,
    address_components,
    formatted_address,
    geometry
  } = locationResponse.results[0]

  const streetNumberFromGoogle =
    address_components.find(({ types }) => types.includes('street_number'))
      ?.long_name || undefined

  const streetNumber = streetNumberFromGoogle
    ? undefined
    : getFirstGroupedNumbersIfExist(label.split(',')[0])
  const streetWithoutNumber = formatted_address.split(',')[0]
  const streetAddress = streetNumber
    ? `${streetWithoutNumber} ${streetNumber}`
    : streetWithoutNumber

  const location: Location = {
    googlePlaceId: place_id,
    streetAddress,
    postalCode: address_components.find(({ types }) =>
      types.includes('postal_code')
    )?.long_name,
    postalArea: address_components.find(
      ({ types }) =>
        types.includes('locality') ||
        types.includes('administrative_area_level_3')
    )?.long_name,
    coordinates: geometry.location
  }
  return location as Location
}

export { getLocationInfo, getPlacesApiUrl }
